function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ppt_svg__clip0)",
  fill: "#0785FE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.938 13.594V1.405c0-.259.21-.469.468-.469h7.032v1.875c0 .518.42.938.937.938h1.875v1.406h.938V3.281a.469.469 0 00-.136-.333L9.239.136A.469.469 0 008.906 0h-7.5C.63 0 0 .63 0 1.406v12.188C0 14.37.63 15 1.406 15h3.282v-.938H1.405a.469.469 0 01-.468-.468z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.094 7.5H4.219a.469.469 0 00-.469.469v4.218h.938v-1.406h1.406c.518 0 .937-.42.937-.937V8.438a.938.938 0 00-.937-.938zm0 2.344H4.687V8.438h1.407v1.406zM9.844 7.5H7.969a.469.469 0 00-.469.469v4.218h.938v-1.406h1.406c.518 0 .937-.42.937-.937V8.438a.937.937 0 00-.937-.938zm0 2.344H8.438V8.438h1.406v1.406zM11.25 7.5v.938h1.406v3.75h.938v-3.75H15V7.5h-3.75z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ppt_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})));

function SvgPpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPpt;